<template>
    <div class="page page-quotes">
        <app-modal
            v-if="isDiscountOpen"
            class="quote-policy-discount"
            hasCloseButton
            small
            @handle-close="handleClose"
        >

            <template>
                <form class="quote-form" @submit.prevent="validateStep">
                    <div class="form-group">
                        <div class="form-row flex center start large-gap">
                            <div class="row-item w-full">
                                <!-- <div class="row-item-title">
                                    {{ `quote-results.static.has_extra_car` | __ }}
                                </div>
                                <div class="form-group">

                                    <app-text-radio-buttons
                                        v-model="form[stepName].hasExtraCar"
                                        :items="yesNoItems"
                                        fixed-mobile
                                    >
                                    </app-text-radio-buttons>
                                </div> -->

                                <div class="row-item-title">
                                    {{ `quote-results.static.estimatedYearlyKm` | __ }}
                                </div>
                                <div class="form-group">
                                    <app-select
                                        v-model="form[stepName].estimatedYearlyKm"
                                        :items="constants.YEARLY_KM_ITEMS"
                                        rounded
                                    ></app-select>
                                </div>

                                <!-- <div class="row-item-title">
                                    {{ `quote-results.static.shabbatDriving` | __ }}
                                </div>
                                <div class="form-group">
                                    <app-text-radio-buttons
                                        v-model="form[stepName].shabbatDriving"
                                        :items="yesNoItems"
                                        fixed-mobile
                                    >
                                    </app-text-radio-buttons>
                                </div> -->

                                <div class="row-item-title">
                                    {{ `quote-results.static.zeroDeductible` | __ }}
                                </div>
                                <div class="form-group">
                                    <app-text-radio-buttons
                                        v-model="form[stepName].zeroDeductible"
                                        :items="yesNoItems"
                                        fixed-mobile
                                    >
                                    </app-text-radio-buttons>
                                </div>

                                <div class="row-item-title">
                                    {{ `quote-results.static.headLightsSideMirrors` | __ }}
                                </div>
                                <div class="form-group">
                                    <app-text-radio-buttons
                                        v-model="form[stepName].headLightsSideMirrors"
                                        :items="yesNoItems"
                                        fixed-mobile
                                    >
                                    </app-text-radio-buttons>
                                </div>
                            </div>
                        </div>

                        <div class="submit-row">
                            <app-button
                                :loading="loading"
                            >
                                {{ `quote-results.static.get_quotes` | __ }}
                            </app-button>
                        </div>
                    </div>
                </form>
            </template>

        </app-modal>

        <policy-details
            :is-policy-details-open="isPolicyDetailsOpen"
            :selected-quote="selectedQuote"
            :quote-type="quoteType"
            :currency="currency"
            @close-policy-details="handlePolicyDetailsClose"
            :policy-includes="policyIncludes"
        />

        <app-modal
            v-if="isProtectionDetailsOpen"
            class="quote-policy-details"
            hasCloseButton
            small
            @handle-close="handleClose"
        >
            <template v-slot:default>

                <div class="protection-info">
                    <p class="protection-info--title">
                        {{ "quote-results.static.protection_header"| __ }}
                    </p>
                    <p class="protection-info--subtitle">
                        <div
                            v-if="selectedQuote.protection_levels.length > 0"
                            class="protections">
                            <p
                                v-for="level in selectedQuote.protection_levels"
                                :key="level.name"
                            >
                                <strong>
                                    {{ level.name }}
                                    {{ (level.name.length > 0) ? ":" : "" }}
                                </strong
                                >
                                {{ level.description }}
                            </p>
                        </div>
                    </p>
                </div>

            </template>
        </app-modal>

        <app-modal
            v-if="isNoFoundOpen"
            class="quote-policy-not-found"
            hasCloseButton
            small
            @handle-close="handleClose"
        >

            <template v-slot:icon>
                <span v-html="$icon('bullseye')"></span>

            </template>

            <template v-slot:title>
                <span v-html="trans('quote-results.static.not_found_title')"/>
            </template>

            <template v-slot:subTitle>
                <span v-html="trans('quote-results.static.not_found_subtitle')"/>
            </template>

        </app-modal>


        <div v-if="loader" class="page-quotes-loader">
            <div class="allsurance-logo">
                <img :src="surely_logo" alt=""/>
            </div>

            <div class="page-loader-progress">


                <div class="scroll-container">
                    <div>
                        <!-- <div class="scroll-content"/> -->
                        <!-- <div class="scroll-content"/> -->
                        <scroll-logos/>
                        <scroll-logos/>
                    </div>
                </div>

                <div class="page-loader-img">
                    <svg fill="none" height="512" viewBox="0 0 855 512" width="855" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_979_5148)">
                            <path
                                d="M608.214 448.048H253.394C248.268 448.048 244.113 444.17 244.113 439.383V262.508H617.495V439.383C617.495 444.17 613.34 448.048 608.214 448.048Z"
                                fill="white" stroke="black" stroke-linecap="round" stroke-linejoin="round"
                                stroke-width="2.54619"/>
                            <path
                                d="M251.93 212.813L251.931 212.813L609.563 212.359C609.563 212.359 609.563 212.359 609.563 212.359C614.116 212.36 617.899 216.29 617.899 221.264V264.597H244.008L243.594 221.718C243.594 221.717 243.594 221.715 243.594 221.713C243.596 216.742 247.386 212.813 251.93 212.813Z"
                                fill="#185AF5" stroke="black" stroke-width="2"/>
                            <path
                                d="M258.152 232.895C261.3 232.895 263.852 230.343 263.852 227.195C263.852 224.048 261.3 221.496 258.152 221.496C255.005 221.496 252.453 224.048 252.453 227.195C252.453 230.343 255.005 232.895 258.152 232.895Z"
                                fill="white"/>
                            <path
                                d="M276.887 232.895C280.034 232.895 282.586 230.343 282.586 227.195C282.586 224.048 280.034 221.496 276.887 221.496C273.739 221.496 271.188 224.048 271.188 227.195C271.188 230.343 273.739 232.895 276.887 232.895Z"
                                fill="white"/>
                            <path
                                d="M295.625 232.895C298.773 232.895 301.324 230.343 301.324 227.195C301.324 224.048 298.773 221.496 295.625 221.496C292.477 221.496 289.926 224.048 289.926 227.195C289.926 230.343 292.477 232.895 295.625 232.895Z"
                                fill="white"/>
                            <path
                                d="M509.225 358.812H342.56C339.049 358.812 336.203 361.659 336.203 365.169V373.882C336.203 377.393 339.049 380.239 342.56 380.239H509.225C512.736 380.239 515.582 377.393 515.582 373.882V365.169C515.582 361.659 512.736 358.812 509.225 358.812Z"
                                stroke="black" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.54619"/>
                            <path
                                d="M390.902 365.609H354.093C352.663 365.609 351.504 366.768 351.504 368.198V370.625C351.504 372.055 352.663 373.214 354.093 373.214H390.902C392.332 373.214 393.491 372.055 393.491 370.625V368.198C393.491 366.768 392.332 365.609 390.902 365.609Z"
                                fill="url(#paint0_linear_979_5148)"/>
                            <path
                                d="M506.904 365.609H485.346C483.917 365.609 482.758 366.768 482.758 368.198V370.625C482.758 372.055 483.917 373.214 485.346 373.214H506.904C508.334 373.214 509.493 372.055 509.493 370.625V368.198C509.493 366.768 508.334 365.609 506.904 365.609Z"
                                fill="url(#paint1_linear_979_5148)"/>
                            <path
                                d="M473.143 365.609H402.448C401.018 365.609 399.859 366.768 399.859 368.198V370.625C399.859 372.055 401.018 373.214 402.448 373.214H473.143C474.573 373.214 475.731 372.055 475.731 370.625V368.198C475.731 366.768 474.573 365.609 473.143 365.609Z"
                                fill="url(#paint2_linear_979_5148)"/>
                            <path d="M596.625 250.297H603.767" stroke="white" stroke-linecap="round"
                                  stroke-linejoin="round" stroke-width="2.54619"/>
                            <path d="M596.625 254.246H603.767" stroke="white" stroke-linecap="round"
                                  stroke-linejoin="round" stroke-width="2.54619"/>
                            <path d="M596.625 258.203H603.767" stroke="white" stroke-linecap="round"
                                  stroke-linejoin="round" stroke-width="2.54619"/>
                            <path
                                d="M584.094 251.968C584.021 251.697 583.861 251.458 583.639 251.288C583.416 251.117 583.144 251.025 582.863 251.026H579.952L579.048 248.254C578.965 248 578.803 247.778 578.586 247.621C578.368 247.464 578.107 247.379 577.839 247.379C577.571 247.379 577.31 247.464 577.092 247.621C576.875 247.778 576.713 248 576.63 248.254L575.73 251.026H572.814C572.547 251.027 572.286 251.112 572.069 251.27C571.853 251.428 571.692 251.651 571.609 251.905C571.526 252.16 571.526 252.435 571.608 252.69C571.691 252.945 571.851 253.167 572.068 253.326L574.423 255.023L573.523 257.794C573.435 258.051 573.431 258.328 573.512 258.587C573.593 258.846 573.755 259.072 573.973 259.233C574.191 259.391 574.453 259.476 574.722 259.476C574.991 259.476 575.253 259.391 575.471 259.233L577.907 257.463L580.296 258.842C580.519 258.971 580.776 259.029 581.033 259.008C581.289 258.988 581.534 258.89 581.734 258.728C581.934 258.566 582.08 258.347 582.153 258.1C582.226 257.852 582.222 257.589 582.142 257.344L581.293 254.675L583.504 253.402C583.747 253.261 583.936 253.044 584.043 252.785C584.149 252.526 584.167 252.238 584.094 251.968Z"
                                fill="white"/>
                            <path
                                d="M559.351 251.023H308.301C307.132 251.023 306.184 251.972 306.184 253.141V257.117C306.184 258.287 307.132 259.235 308.301 259.235H559.351C560.52 259.235 561.468 258.287 561.468 257.117V253.141C561.468 251.972 560.52 251.023 559.351 251.023Z"
                                fill="white"/>
                            <path d="M265.186 250.676L260.98 254.563L265.343 258.531" stroke="white"
                                  stroke-linecap="round" stroke-linejoin="round" stroke-width="2.54619"/>
                            <path d="M271.611 254.645H260.98" stroke="white" stroke-linecap="round"
                                  stroke-linejoin="round" stroke-width="2.54619"/>
                            <path d="M286.169 250.676L290.374 254.563L286.012 258.531" stroke="white"
                                  stroke-linecap="round" stroke-linejoin="round" stroke-width="2.54619"/>
                            <path d="M279.746 254.645H290.376" stroke="white" stroke-linecap="round"
                                  stroke-linejoin="round" stroke-width="2.54619"/>
                            <path d="M593.83 228.438L593.172 231.786L596.669 232.159" stroke="white"
                                  stroke-linecap="round" stroke-linejoin="round" stroke-width="2.54619"/>
                            <path d="M598.317 228.086L593.203 231.825" stroke="white" stroke-linecap="round"
                                  stroke-linejoin="round" stroke-width="2.54619"/>
                            <path d="M603.449 221.594L606.84 221.984L606.135 225.43" stroke="white"
                                  stroke-linecap="round" stroke-linejoin="round" stroke-width="2.54619"/>
                            <path d="M601.75 225.766L606.864 222.023" stroke="white" stroke-linecap="round"
                                  stroke-linejoin="round" stroke-width="2.54619"/>
                            <path
                                d="M653.843 289.696L565.915 289.466C560.832 289.452 556.7 293.562 556.687 298.646L556.496 371.526C556.483 376.609 560.593 380.741 565.676 380.754L653.604 380.985C658.688 380.998 662.82 376.888 662.833 371.804L663.024 298.924C663.037 293.841 658.927 289.709 653.843 289.696Z"
                                fill="#DEEBFF"/>
                            <path
                                d="M621.852 336.281V355.484C621.852 356.789 622.91 357.848 624.215 357.848H643.078C644.384 357.848 645.442 356.789 645.442 355.484V336.281C645.442 334.976 644.384 333.918 643.078 333.918H624.215C622.91 333.918 621.852 334.976 621.852 336.281Z"
                                fill="white" fill-opacity="0.83"/>
                            <path
                                d="M640.816 309.451L579.402 309.291C577.422 309.285 575.812 310.887 575.807 312.867L575.782 322.534C575.777 324.515 577.378 326.124 579.358 326.129L640.772 326.29C642.752 326.295 644.362 324.694 644.367 322.714L644.393 313.047C644.398 311.066 642.797 309.457 640.816 309.451Z"
                                fill="white" fill-opacity="0.83"/>
                            <path d="M576.637 356.363L615.475 356.474" stroke="white" stroke-linecap="round"
                                  stroke-linejoin="round" stroke-opacity="0.83" stroke-width="2.54619"/>
                            <path d="M576.664 346.23L615.502 346.341" stroke="white" stroke-linecap="round"
                                  stroke-linejoin="round" stroke-opacity="0.83" stroke-width="2.54619"/>
                            <path d="M576.695 336.098L615.533 336.212" stroke="white" stroke-linecap="round"
                                  stroke-linejoin="round" stroke-opacity="0.83" stroke-width="2.54619"/>
                            <path
                                d="M258.512 392.301H151.666C148.155 392.301 145.309 395.147 145.309 398.658V427.646C145.309 431.157 148.155 434.003 151.666 434.003H258.512C262.023 434.003 264.869 431.157 264.869 427.646V398.658C264.869 395.147 262.023 392.301 258.512 392.301Z"
                                fill="#2C79EE"/>
                            <path d="M161.305 408.344H246.971" stroke="#478AF0" stroke-linecap="round"
                                  stroke-linejoin="round" stroke-width="2.54619"/>
                            <path d="M161.305 417.543H236.939" stroke="#478AF0" stroke-linecap="round"
                                  stroke-linejoin="round" stroke-width="2.54619"/>
                            <path
                                d="M335.981 162.132L335.98 162.131C331.373 107.239 372.097 58.9853 426.988 54.3582C481.88 49.731 530.133 90.4787 534.776 145.371C539.388 200.263 498.645 248.511 443.753 253.139L443.752 253.139C434.925 253.889 426.039 253.459 417.327 251.86C416.665 249.969 415.677 248.397 414.223 247.349C412.605 246.183 410.549 245.764 408.061 246.088C400.602 247.055 396.804 253.594 394.87 260.039C393.371 265.032 392.903 270.228 392.766 273.456L391.541 272.254C388.141 268.095 382.072 261.213 374.745 255.258L383.874 240.346L384.398 239.49L383.54 238.969C370.115 230.82 358.808 219.61 350.542 206.256C342.277 192.902 337.287 177.782 335.981 162.132ZM397.127 222.943C410.812 230.507 426.433 233.843 442.015 232.529C462.908 230.767 482.245 220.778 495.774 204.759C509.302 188.74 515.912 168.003 514.152 147.109C512.838 131.528 506.934 116.686 497.185 104.46C487.437 92.2343 474.282 83.1738 459.384 78.4245C444.486 73.6753 428.514 73.4504 413.488 77.7785C398.463 82.1065 385.058 90.7931 374.969 102.74C364.88 114.686 358.56 129.356 356.809 144.895C355.058 160.433 357.953 176.142 365.13 190.034C372.306 203.927 383.441 215.379 397.127 222.943Z"
                                fill="url(#paint3_linear_979_5148)" stroke="black" stroke-width="2"/>
                            <path
                                d="M393.724 276.672C393.724 276.672 392.888 249.066 408.19 247.084C423.492 245.103 415.841 273.925 414.325 299.549C412.809 325.174 410.067 344.428 410.577 360.596C411.087 376.763 432.824 525.432 432.824 525.432L333.503 525.757L334.619 383.808C334.619 383.808 290.14 351.929 291.696 305.694C294.748 268.38 321.094 251.117 343.951 245.348C366.809 239.578 393.724 276.672 393.724 276.672Z"
                                fill="white" stroke="black" stroke-linecap="round" stroke-linejoin="round"
                                stroke-width="3.00229"/>
                            <path
                                d="M287.513 383.141L287.513 383.141C286.729 384.41 286.816 386.276 287.974 388.429C289.117 390.556 291.22 392.771 294.043 394.515L294.044 394.515L297.115 396.416L287.513 383.141ZM287.513 383.141L314.167 339.918L335.252 355.854L310.205 397.172C310.204 397.173 310.204 397.174 310.203 397.175M287.513 383.141L310.203 397.175M310.203 397.175C309.418 398.442 307.714 399.196 305.273 399.123C302.861 399.051 299.939 398.16 297.116 396.417L310.203 397.175Z"
                                fill="url(#paint4_linear_979_5148)" stroke="black" stroke-width="2"/>
                            <path
                                d="M309.266 335.247C309.266 335.247 340.745 360.376 352.799 362.948C364.853 365.52 373.555 362.693 375.211 354.652C376.867 346.611 350.367 322.888 326.058 313.16"
                                stroke="black" stroke-linecap="round" stroke-linejoin="round" stroke-width="3.00229"/>
                            <path
                                d="M332.984 287.117C332.984 287.117 364.093 301.593 380.521 320.973C396.283 338.321 388.257 358.817 374.446 350.706"
                                stroke="black" stroke-linecap="round" stroke-linejoin="round" stroke-width="3.00229"/>
                            <path
                                d="M336.773 264.863C336.773 264.863 375.573 277.213 391.265 304.694C406.957 332.175 388.663 336.218 388.663 336.218"
                                stroke="black" stroke-linecap="round" stroke-linejoin="round" stroke-width="3.00229"/>
                            <path d="M393.578 275.727C411.447 307.921 395.58 314.141 395.58 314.141" stroke="black"
                                  stroke-linecap="round" stroke-linejoin="round" stroke-width="3.00229"/>
                            <path d="M141.035 510.25H717.725" stroke="black" stroke-linecap="round"
                                  stroke-linejoin="round" stroke-width="2.54619"/>
                        </g>
                        <defs>
                            <linearGradient id="paint0_linear_979_5148" gradientUnits="userSpaceOnUse" x1="347.627"
                                            x2="398.597"
                                            y1="369.412" y2="369.412">
                                <stop stop-color="#185AF5"/>
                                <stop offset="1" stop-color="#72E1D1"/>
                            </linearGradient>
                            <linearGradient id="paint1_linear_979_5148" gradientUnits="userSpaceOnUse" x1="480.289"
                                            x2="512.744"
                                            y1="369.412" y2="369.412">
                                <stop stop-color="#185AF5"/>
                                <stop offset="1" stop-color="#72E1D1"/>
                            </linearGradient>
                            <linearGradient id="paint2_linear_979_5148" gradientUnits="userSpaceOnUse" x1="392.853"
                                            x2="484.959"
                                            y1="369.412" y2="369.412">
                                <stop stop-color="#185AF5"/>
                                <stop offset="1" stop-color="#72E1D1"/>
                            </linearGradient>
                            <linearGradient id="paint3_linear_979_5148" gradientUnits="userSpaceOnUse" x1="316.017"
                                            x2="560.64"
                                            y1="164.393" y2="164.393">
                                <stop stop-color="#185AF5"/>
                                <stop offset="1" stop-color="#72E1D1"/>
                            </linearGradient>
                            <linearGradient id="paint4_linear_979_5148" gradientUnits="userSpaceOnUse" x1="281.33"
                                            x2="342.726"
                                            y1="369.292" y2="369.292">
                                <stop stop-color="#185AF5"/>
                                <stop offset="1" stop-color="#72E1D1"/>
                            </linearGradient>
                            <clipPath id="clip0_979_5148">
                                <rect fill="white" height="512" width="855"/>
                            </clipPath>
                        </defs>
                    </svg>
                </div>

            </div>

            <div class="page-loader-text">{{ calcTitle }}</div>

            <!--            <div class="page-loader-sub-text">{{ calcSubTitle }}</div>-->

        </div>

        <div v-if="quoteType === 'car'" class="page-quotes-header cursor-pointer disabled" @click="handleDiscountClick">
            <div v-if="isPageDisabled" class="animation-container">
                <div class="pointer-icon" style="transform: rotate(90deg);" v-html="$icon('pointer')"></div>
            </div>

            <div class="header-inner">
                <div class="header-inner-container">
                    <div class="header-title-section">
                        <div class="header-inner-title">
                            {{ "quote-results.static.banner_title" | __ }}
                        </div>
                        <div class="header-inner-subtitle">
                            {{ "quote-results.static.banner_subtitle" | __ }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="header-logo-section">
                <svg
                    fill="none"
                    height="100%"
                    viewBox="0 0 348 348"
                    width="100%"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M260.913 87.1175C269.842 90.1226 275.125 93.7559 275.012 97.5397C274.897 101.48 270.524 119.798 268.866 123.37C267.26 126.785 260.902 127.648 251.576 126.303C255.694 134.779 256.808 141.093 254.034 143.661C251.263 146.229 235.937 155.654 232.364 156.979C228.792 158.304 223.684 154.455 217.976 146.953C214.971 155.883 211.338 161.169 207.562 161.056C203.621 160.937 185.297 156.562 181.725 154.889C178.31 153.284 177.443 146.925 178.792 137.6C170.323 141.718 164.005 142.828 161.437 140.055C158.869 137.282 149.441 121.956 148.119 118.388C146.798 114.819 150.65 109.707 158.145 104.007C149.215 100.996 143.936 97.3621 144.049 93.5852C144.165 89.641 148.532 71.3203 150.195 67.7483C151.8 64.3334 158.159 63.4695 167.482 64.815C163.367 56.3461 162.253 50.0285 165.03 47.4606C167.806 44.8925 183.128 35.4642 186.7 34.1426C190.272 32.8211 195.377 36.6729 201.074 44.1687C204.089 35.2388 207.723 29.9593 211.498 30.0721C215.439 30.1916 233.76 34.5592 237.332 36.2188C240.748 37.8238 241.614 44.1823 240.266 53.5083C248.738 49.3899 255.056 48.2801 257.624 51.053C260.192 53.8259 269.616 69.1518 270.942 72.7238C272.266 76.2957 268.412 81.4113 260.913 87.1175Z"
                        fill="white"
                    />
                    <path
                        d="M207.671 163.106H207.483C203.307 162.983 184.628 158.527 180.847 156.747C177.068 154.968 175.547 149.672 176.326 140.974C168.274 144.355 162.766 144.519 159.935 141.452C157.104 138.386 147.641 122.971 146.193 119.105C144.735 115.185 147.368 110.343 154.024 104.688C145.91 101.447 141.867 97.701 141.993 93.528C142.119 89.3549 146.572 70.6722 148.345 66.8921C150.117 63.1117 155.424 61.5887 164.121 62.3672C160.741 54.3185 160.577 48.8101 163.643 45.9759C166.71 43.1416 182.127 33.6824 185.994 32.2311C189.914 30.7763 194.753 33.4092 200.408 40.0647C203.58 32.0637 207.258 28.0137 211.356 28.0137H211.544C215.727 28.14 234.399 32.593 238.18 34.3687C241.961 36.1445 243.48 41.4444 242.704 50.1419C250.753 46.7613 256.262 46.5974 259.096 49.664C261.931 52.7305 271.389 68.1487 272.837 72.0143C274.295 75.9312 271.659 80.7734 265.004 86.4352C273.117 89.6657 277.161 93.4119 277.037 97.5951C276.914 101.778 272.458 120.444 270.683 124.231C268.906 128.018 263.606 129.534 254.906 128.756C258.291 136.812 258.454 142.32 255.387 145.147C252.321 147.975 236.903 157.441 233.04 158.882C229.12 160.34 224.274 157.707 218.615 151.055C215.454 159.063 211.768 163.106 207.671 163.106ZM178.774 135.551C179.068 135.551 179.359 135.614 179.627 135.737C179.893 135.859 180.132 136.037 180.325 136.259C180.516 136.481 180.659 136.742 180.742 137.024C180.824 137.307 180.845 137.603 180.803 137.894C179.376 147.773 180.782 152.192 182.578 153.035C185.915 154.6 203.928 158.899 207.606 159.008H207.658C209.642 159.008 212.861 155.679 216.021 146.301C216.139 145.949 216.351 145.635 216.635 145.394C216.919 145.153 217.263 144.994 217.63 144.933C217.998 144.873 218.373 144.914 218.72 145.051C219.066 145.189 219.367 145.418 219.593 145.714C225.633 153.657 229.772 155.75 231.634 155.057C234.933 153.831 250.04 144.546 252.625 142.156C254.08 140.81 254.08 136.173 249.718 127.195C249.556 126.86 249.488 126.488 249.521 126.117C249.554 125.747 249.688 125.392 249.907 125.092C250.127 124.791 250.422 124.557 250.767 124.412C251.11 124.268 251.484 124.219 251.853 124.272C261.732 125.7 266.15 124.289 266.994 122.496C268.558 119.16 272.851 101.157 272.964 97.4755C273.022 95.4916 269.712 92.2371 260.253 89.0579C259.9 88.9396 259.585 88.727 259.343 88.4432C259.102 88.1594 258.943 87.815 258.882 87.4472C258.821 87.0794 258.863 86.7021 259.001 86.3559C259.14 86.0098 259.369 85.7077 259.665 85.4826C267.612 79.4416 269.709 75.3029 269.02 73.4451C267.789 70.1464 258.501 55.0355 256.107 52.4504C254.762 50.9958 250.125 50.9958 241.153 55.3566C240.819 55.5199 240.447 55.589 240.075 55.5561C239.704 55.5234 239.349 55.3901 239.048 55.1707C238.747 54.9511 238.512 54.6538 238.368 54.3105C238.223 53.9672 238.175 53.591 238.227 53.2223C239.659 43.3431 238.248 38.9242 236.455 38.0808C233.118 36.503 215.113 32.2241 211.427 32.1149H211.377C209.391 32.1149 206.169 35.4445 203.006 44.8182C202.887 45.1706 202.675 45.484 202.391 45.7246C202.108 45.9652 201.763 46.1241 201.396 46.1841C201.029 46.2442 200.653 46.2031 200.307 46.0653C199.961 45.9275 199.66 45.6983 199.435 45.4022C193.397 37.4593 189.261 35.3659 187.405 36.0558C184.102 37.2851 168.994 46.5736 166.409 48.9673C164.955 50.3128 164.955 54.9501 169.315 63.921C169.478 64.2556 169.546 64.6283 169.513 64.9988C169.48 65.3694 169.346 65.7238 169.127 66.0243C168.908 66.3246 168.611 66.5597 168.268 66.7041C167.925 66.8487 167.549 66.8971 167.181 66.8442C157.302 65.4167 152.883 66.8237 152.04 68.6199C150.476 71.9528 146.183 89.9629 146.074 93.6475C146.012 95.6247 149.318 98.8757 158.777 102.069C159.13 102.188 159.443 102.401 159.684 102.684C159.924 102.968 160.083 103.312 160.143 103.679C160.203 104.046 160.162 104.423 160.024 104.768C159.886 105.114 159.657 105.415 159.361 105.64C151.418 111.678 149.325 115.817 150.018 117.674C151.244 120.977 160.532 136.081 162.923 138.666C164.272 140.12 168.909 140.12 177.88 135.76C178.158 135.623 178.465 135.551 178.774 135.551Z"
                        fill="#101014"
                    />
                    <path
                        d="M213.211 142.933C212.835 142.933 212.468 142.83 212.148 142.635C211.828 142.441 211.567 142.162 211.393 141.83L187.216 95.5342C187.031 95.1819 186.955 94.7827 186.995 94.3869L189.419 69.4583C189.45 69.1303 189.558 68.8143 189.737 68.5373C189.914 68.2603 190.158 68.0302 190.443 67.867L200.937 62.0071C201.244 61.8346 201.59 61.7441 201.941 61.7441C202.293 61.7441 202.639 61.8346 202.945 62.0071L222.773 73.2386C223.107 73.4275 223.382 73.7068 223.564 74.0444L249.518 121.962C249.647 122.201 249.727 122.463 249.753 122.733C249.781 123.003 249.753 123.276 249.675 123.535C249.595 123.795 249.464 124.036 249.29 124.245C249.118 124.454 248.904 124.626 248.664 124.752L214.153 142.704C213.862 142.854 213.538 142.933 213.211 142.933ZM191.131 94.1784L214.088 138.121L244.935 122.071L220.258 76.5065L201.945 66.1322L193.408 70.9131L191.131 94.1784Z"
                        fill="#101014"
                    />
                    <path
                        d="M203.398 86.2375C202.21 86.2366 201.039 85.9528 199.981 85.4094C198.923 84.866 198.011 84.0787 197.317 83.1124C196.624 82.1462 196.172 81.029 195.996 79.8531C195.82 78.6772 195.928 77.4766 196.309 76.3503C196.69 75.224 197.332 74.2045 198.187 73.3763C199.039 72.548 200.076 71.9347 201.214 71.587C202.351 71.2394 203.555 71.1675 204.724 71.3772C205.895 71.587 206.998 72.0723 207.943 72.793C209.19 73.7436 210.107 75.0615 210.565 76.5606C211.023 78.06 211 79.6653 210.497 81.1502C209.994 82.6353 209.037 83.925 207.764 84.8376C206.488 85.7503 204.959 86.2399 203.391 86.2375H203.398ZM203.398 75.3576C202.592 75.3593 201.815 75.6473 201.202 76.17C200.59 76.6929 200.182 77.4165 200.054 78.2117C199.927 79.0069 200.085 79.8216 200.503 80.5106C200.919 81.1995 201.568 81.7175 202.331 81.9722C203.095 82.2269 203.925 82.2015 204.673 81.9009C205.42 81.6 206.036 81.0434 206.41 80.3303C206.784 79.6175 206.894 78.7945 206.718 78.0085C206.54 77.2227 206.092 76.5251 205.448 76.0406C204.861 75.597 204.146 75.3571 203.412 75.3576H203.398Z"
                        fill="#101014"
                    />
                    <path
                        d="M283.475 245.543C293.543 262.442 295.26 277.263 282.24 289.911C269.67 302.126 255.467 300.553 239.554 290.936C234.851 308.937 225.758 319.963 208.229 319.963C190.086 319.963 180.982 308.147 176.424 289.01C159.523 299.071 144.702 300.788 132.047 287.761C119.832 275.191 121.406 260.987 131.023 245.075C113.04 240.363 101.996 231.286 101.996 213.743C101.996 195.59 113.812 186.496 132.949 181.937C122.881 165.034 121.164 150.213 134.191 137.561C146.762 125.346 160.964 126.917 176.878 136.537C181.59 118.554 187.784 135.625 205.327 135.625C223.473 135.625 235.467 119.346 240.026 138.483C256.928 128.416 271.749 126.698 284.394 139.716C296.609 152.286 295.036 166.492 285.419 182.402C303.412 187.111 314.446 196.199 314.446 213.732C314.446 231.889 302.61 240.984 283.475 245.543Z"
                        fill="#3382EB"
                    />
                    <path
                        d="M270.502 233.588C280.568 250.487 282.287 265.308 269.265 277.956C256.695 290.171 242.493 288.598 226.579 278.981C221.878 296.981 212.783 308.007 195.254 308.007C177.111 308.007 168.007 296.191 163.449 277.055C146.548 287.115 131.728 288.833 119.072 275.805C106.857 263.236 108.432 249.032 118.048 233.12C100.065 228.406 89.0215 219.33 89.0215 201.787C89.0215 183.634 100.837 174.541 119.974 169.982C109.907 153.078 108.189 138.258 121.217 125.606C133.787 113.391 147.99 114.961 163.903 124.581C168.615 106.598 177.702 95.5547 195.245 95.5547C213.392 95.5547 222.492 107.38 227.051 126.517C243.955 116.45 258.774 114.733 271.421 127.75C283.635 140.32 282.061 154.526 272.444 170.436C290.437 175.145 301.47 184.233 301.47 201.767C301.47 219.934 289.635 229.029 270.502 233.588Z"
                        fill="url(#paint0_linear_1043_2424)"
                    />
                    <path
                        d="M196.55 289.515C189.127 289.515 183.047 287.097 178.481 282.343C174.834 278.529 172.082 273.212 170.112 266.14C163.665 269.653 157.934 271.385 152.655 271.426H152.467C145.938 271.426 140.03 268.752 134.901 263.473C134.714 263.28 134.566 263.052 134.467 262.801C134.368 262.552 134.318 262.284 134.322 262.015C134.326 261.747 134.383 261.48 134.49 261.233C134.597 260.986 134.751 260.764 134.944 260.576C135.137 260.388 135.365 260.24 135.615 260.141C135.865 260.042 136.132 259.993 136.401 259.996C136.671 260 136.936 260.057 137.183 260.163C137.43 260.271 137.654 260.424 137.841 260.617C146.362 269.391 156.398 269.592 170.378 261.273C170.654 261.11 170.965 261.012 171.285 260.992C171.606 260.969 171.927 261.023 172.222 261.148C172.518 261.273 172.78 261.465 172.988 261.71C173.196 261.956 173.343 262.246 173.418 262.558C177.175 278.379 184.321 285.437 196.55 285.437C204.858 285.437 210.892 282.023 214.99 275.016C215.282 274.588 215.724 274.287 216.229 274.172C216.734 274.057 217.264 274.137 217.711 274.398C218.159 274.658 218.493 275.079 218.642 275.573C218.794 276.069 218.752 276.603 218.524 277.067C213.699 285.329 206.302 289.515 196.55 289.515Z"
                        fill="white"
                    />
                    <path
                        d="M239.411 272.63C234.256 272.63 228.665 270.963 222.587 267.636L222.325 268.628C222.255 268.887 222.135 269.13 221.971 269.345C221.808 269.559 221.602 269.738 221.369 269.872C221.136 270.007 220.879 270.094 220.612 270.129C220.346 270.166 220.075 270.148 219.814 270.079C219.554 270.009 219.311 269.889 219.097 269.726C218.883 269.562 218.704 269.357 218.568 269.124C218.434 268.89 218.347 268.633 218.31 268.367C218.276 268.1 218.293 267.829 218.363 267.568L219.32 263.999C219.401 263.693 219.554 263.409 219.765 263.171C219.976 262.934 220.238 262.748 220.534 262.63C220.828 262.512 221.147 262.463 221.463 262.489C221.78 262.513 222.086 262.612 222.358 262.778C235.448 270.693 245.08 270.533 253.594 262.257C262.367 253.742 262.566 243.709 254.24 229.728C254.076 229.452 253.979 229.142 253.956 228.822C253.935 228.502 253.989 228.18 254.114 227.884C254.238 227.588 254.431 227.325 254.676 227.118C254.922 226.911 255.211 226.763 255.524 226.688C267.509 223.831 274.359 219.071 277.079 211.707C277.171 211.455 277.314 211.223 277.496 211.027C277.679 210.828 277.898 210.668 278.144 210.557C278.387 210.444 278.652 210.381 278.922 210.371C279.189 210.36 279.459 210.402 279.711 210.496C279.964 210.588 280.195 210.731 280.394 210.914C280.59 211.096 280.75 211.317 280.862 211.561C280.975 211.806 281.039 212.069 281.05 212.339C281.06 212.608 281.016 212.876 280.923 213.129C277.945 221.188 270.797 226.72 259.106 229.991C262.619 236.438 264.354 242.169 264.399 247.448C264.453 254.052 261.779 260.025 256.453 265.205C251.355 270.154 245.705 272.626 239.411 272.63Z"
                        fill="white"
                    />
                    <path
                        d="M280.465 205.602C279.923 205.602 279.402 205.386 279.018 205.002C278.633 204.619 278.417 204.097 278.417 203.554C278.417 191.68 271.816 184.659 257.014 180.783C256.704 180.703 256.419 180.551 256.18 180.341C255.94 180.13 255.754 179.866 255.634 179.572C255.514 179.276 255.465 178.956 255.491 178.639C255.516 178.321 255.615 178.013 255.78 177.741C259.196 172.106 261.045 167.155 261.466 162.637C261.515 162.095 261.778 161.596 262.197 161.249C262.615 160.901 263.152 160.734 263.694 160.784C264.235 160.834 264.734 161.097 265.082 161.514C265.43 161.932 265.597 162.471 265.547 163.012C265.131 167.52 263.514 172.297 260.623 177.55C275.348 182.081 282.515 190.608 282.515 203.554C282.515 204.097 282.299 204.619 281.915 205.002C281.53 205.386 281.01 205.602 280.465 205.602Z"
                        fill="white"
                    />
                    <path
                        d="M256.726 147.125C256.451 147.125 256.18 147.07 255.925 146.963C255.673 146.856 255.445 146.7 255.254 146.503C246.733 137.734 236.7 137.536 222.723 145.861C222.448 146.026 222.136 146.123 221.815 146.146C221.494 146.168 221.172 146.114 220.877 145.989C220.581 145.864 220.318 145.671 220.111 145.426C219.902 145.181 219.754 144.89 219.681 144.577C215.925 128.749 208.777 121.697 196.548 121.697C196.005 121.697 195.483 121.482 195.099 121.097C194.716 120.713 194.5 120.192 194.5 119.649C194.5 119.105 194.716 118.584 195.099 118.2C195.483 117.816 196.005 117.6 196.548 117.6C203.976 117.6 210.054 120.017 214.616 124.791C218.267 128.609 221.016 133.926 222.989 140.995C229.434 137.481 235.164 135.75 240.443 135.705H240.638C247.163 135.705 253.068 138.379 258.193 143.652C258.475 143.94 258.663 144.305 258.737 144.701C258.812 145.097 258.767 145.506 258.61 145.876C258.454 146.247 258.193 146.564 257.857 146.786C257.521 147.009 257.128 147.128 256.726 147.128V147.125Z"
                        fill="white"
                    />
                    <path
                        d="M130.302 254.131C129.858 254.13 129.427 253.985 129.073 253.719C128.719 253.451 128.461 253.077 128.338 252.652C126.351 245.823 127.703 238.252 132.477 229.557C117.762 225.03 110.598 216.502 110.598 203.556C110.598 196.125 113.015 190.047 117.786 185.485C121.6 181.838 126.917 179.089 133.986 177.115C130.472 170.671 128.738 164.937 128.696 159.661C128.645 153.057 131.319 147.081 136.65 141.904C145.935 132.882 157.043 132.079 170.542 139.48C173.011 131.421 176.601 125.735 181.469 122.146C181.687 121.986 181.932 121.871 182.193 121.806C182.456 121.741 182.727 121.729 182.992 121.769C183.258 121.809 183.514 121.902 183.745 122.041C183.975 122.18 184.175 122.363 184.335 122.579C184.495 122.796 184.61 123.042 184.674 123.303C184.739 123.564 184.752 123.836 184.711 124.102C184.671 124.368 184.578 124.623 184.439 124.854C184.302 125.084 184.117 125.285 183.902 125.445C179.315 128.825 176.002 134.596 173.78 143.086C173.699 143.394 173.547 143.679 173.336 143.918C173.126 144.158 172.863 144.345 172.567 144.464C172.272 144.584 171.952 144.633 171.635 144.608C171.317 144.583 171.01 144.483 170.737 144.318C157.651 136.41 148.018 136.57 139.505 144.844C130.732 153.381 130.53 163.404 138.856 177.382C139.02 177.657 139.117 177.968 139.139 178.288C139.161 178.608 139.107 178.93 138.982 179.226C138.858 179.522 138.665 179.785 138.42 179.993C138.175 180.2 137.884 180.348 137.572 180.423C121.751 184.18 114.692 191.328 114.692 203.556C114.692 215.427 121.286 222.448 136.083 226.323C136.391 226.404 136.676 226.556 136.916 226.766C137.155 226.977 137.342 227.24 137.462 227.535C137.581 227.831 137.63 228.15 137.605 228.468C137.58 228.786 137.481 229.093 137.316 229.366C132.094 238.001 130.445 245.245 132.268 251.507C132.42 252.029 132.358 252.59 132.097 253.065C131.835 253.54 131.396 253.893 130.875 254.044C130.689 254.102 130.496 254.13 130.302 254.131Z"
                        fill="white"
                    />
                    <path
                        d="M122.599 224.777C116.001 232.666 119.006 242.897 112.658 246.257C106.2 249.671 99.3606 241.134 88.8393 242.064C78.3182 242.993 73.1036 252.629 66.1373 250.412C59.2972 248.223 60.4413 237.637 52.5633 231.034C44.6851 224.429 34.4439 227.441 31.0871 221.097C27.6722 214.638 36.2093 207.798 35.2771 197.281C34.3449 186.763 24.7114 181.541 26.9278 174.572C29.1065 167.742 39.7097 168.879 46.3071 160.987C52.9046 153.096 49.903 142.861 56.2444 139.511C62.7089 136.096 69.5624 144.634 80.0666 143.701C90.5708 142.769 95.7887 133.143 102.762 135.352C109.592 137.531 108.458 148.134 116.346 154.731C124.235 161.329 134.472 158.324 137.829 164.669C141.244 171.136 132.707 177.969 133.639 188.491C134.571 199.013 144.201 204.224 141.981 211.193C139.8 218.032 129.196 216.889 122.599 224.777Z"
                        fill="white"
                    />
                    <path
                        d="M68.2721 252.799C67.3445 252.795 66.4232 252.649 65.5401 252.366C61.1009 250.947 59.4446 246.973 57.6859 242.766C56.2005 239.176 54.6637 235.465 51.2455 232.606C47.8273 229.749 43.8933 228.891 40.0959 228.075C35.6567 227.106 31.446 226.191 29.2639 222.065C27.0409 217.868 28.7278 213.818 30.5138 209.528C32.047 205.852 33.6317 202.043 33.2252 197.472C32.8189 192.899 30.5787 189.416 28.4171 186.072C25.9003 182.158 23.5372 178.475 24.9647 173.95C26.3785 169.51 30.3533 167.857 34.5605 166.116C38.1529 164.63 41.8615 163.094 44.7231 159.672C47.5847 156.25 48.4351 152.327 49.2649 148.529C50.2347 144.09 51.15 139.879 55.275 137.697C59.4719 135.478 63.5219 137.165 67.811 138.951C71.4923 140.484 75.2965 142.068 79.8723 141.662C84.4483 141.256 87.9076 139.019 91.2575 136.857C95.1641 134.337 98.8522 131.96 103.377 133.398C107.816 134.815 109.469 138.79 111.214 142.997C112.7 146.586 114.236 150.298 117.655 153.157C121.073 156.015 125 156.872 128.797 157.702C133.237 158.671 137.45 159.587 139.636 163.712C141.852 167.909 140.169 171.959 138.383 176.244C136.849 179.926 135.265 183.733 135.671 188.309C136.078 192.885 138.314 196.351 140.476 199.701C142.993 203.604 145.37 207.289 143.928 211.813C142.511 216.254 138.536 217.907 134.329 219.647C130.74 221.133 127.028 222.669 124.17 226.092C121.312 229.505 120.455 233.436 119.628 237.231C118.658 241.67 117.743 245.881 113.618 248.066C109.425 250.286 105.375 248.598 101.089 246.813C97.4044 245.28 93.5967 243.692 89.0207 244.101C84.4449 244.511 80.9856 246.744 77.6322 248.906C74.5486 250.897 71.5981 252.799 68.2721 252.799ZM59.5368 140.754C58.7188 140.745 57.9114 140.94 57.1874 141.321C54.8652 142.55 54.1858 145.193 53.267 149.403C52.3793 153.484 51.3718 158.108 47.8649 162.301C44.3577 166.495 39.9867 168.315 36.1279 169.903C32.1462 171.549 29.6839 172.686 28.8679 175.193C28.0517 177.699 29.4757 180.143 31.8628 183.843C34.0653 187.256 36.8075 191.513 37.306 197.1C37.8045 202.685 35.8582 207.343 34.2976 211.1C32.5901 215.164 31.6305 217.773 32.8838 220.142C34.137 222.512 36.7597 223.147 40.9701 224.063C45.068 224.954 49.6746 225.961 53.8647 229.465C58.0548 232.968 59.8681 237.342 61.4663 241.202C63.1156 245.185 64.2527 247.666 66.7593 248.463C69.2658 249.258 71.7109 247.854 75.4125 245.466C78.8275 243.265 83.079 240.523 88.6555 240.024C94.2319 239.526 98.9001 241.471 102.656 243.032C106.72 244.739 109.329 245.7 111.696 244.447C114.062 243.192 114.701 240.574 115.619 236.363C116.507 232.265 117.514 227.659 121.018 223.466C124.525 219.273 128.896 217.461 132.755 215.867C136.737 214.218 139.219 213.08 140.015 210.574C140.811 208.067 139.411 205.622 137.024 201.925C134.824 198.509 132.082 194.258 131.584 188.678C131.085 183.098 133.028 178.433 134.592 174.676C136.3 170.613 137.259 168.004 136.006 165.634C134.753 163.265 132.13 162.629 127.92 161.711C123.822 160.823 119.212 159.812 115.018 156.308C110.825 152.805 109.018 148.43 107.42 144.572C105.771 140.59 104.634 138.111 102.127 137.311C99.6206 136.512 97.1824 137.923 93.4807 140.313C90.0658 142.516 85.8143 145.258 80.2344 145.756C74.6544 146.255 69.9898 144.312 66.2333 142.748C63.4502 141.577 61.3467 140.754 59.5368 140.754Z"
                        fill="#101014"
                    />
                    <path
                        d="M150.527 236.677C149.679 236.673 148.856 236.396 148.178 235.887C147.501 235.377 147.007 234.662 146.77 233.847C146.533 233.033 146.566 232.165 146.863 231.371C147.16 230.578 147.707 229.901 148.42 229.443L240.489 171.049C240.924 170.766 241.411 170.571 241.923 170.477C242.434 170.383 242.958 170.391 243.466 170.502C243.974 170.612 244.456 170.822 244.883 171.12C245.309 171.417 245.671 171.796 245.949 172.235C246.228 172.674 246.415 173.164 246.504 173.677C246.591 174.19 246.577 174.713 246.461 175.22C246.344 175.726 246.128 176.205 245.824 176.627C245.521 177.05 245.138 177.409 244.696 177.682L152.624 236.066C151.997 236.464 151.27 236.677 150.527 236.677Z"
                        fill="white"
                    />
                    <path
                        d="M187.324 180.246C184.221 180.243 181.201 179.241 178.712 177.388C176.224 175.533 174.399 172.927 173.506 169.955C172.614 166.983 172.703 163.803 173.759 160.885C174.815 157.967 176.783 155.467 179.372 153.755C181.959 152.043 185.03 151.21 188.129 151.379C191.228 151.548 194.19 152.711 196.575 154.694C198.961 156.678 200.645 159.377 201.378 162.393C202.11 165.408 201.853 168.58 200.642 171.437C199.532 174.05 197.677 176.279 195.309 177.847C192.94 179.413 190.163 180.248 187.324 180.246ZM187.345 159.208C185.707 159.205 184.127 159.811 182.911 160.907C181.695 162.004 180.929 163.513 180.764 165.142C180.597 166.771 181.042 168.403 182.011 169.723C182.981 171.042 184.406 171.955 186.01 172.283C187.614 172.611 189.283 172.331 190.692 171.499C192.102 170.666 193.153 169.339 193.64 167.775C194.125 166.212 194.014 164.523 193.327 163.038C192.638 161.552 191.423 160.374 189.916 159.734C189.104 159.387 188.228 159.208 187.345 159.208Z"
                        fill="white"
                    />
                    <path
                        d="M202.554 261.587C198.956 261.595 195.484 260.264 192.817 257.851C190.148 255.439 188.474 252.119 188.119 248.54C187.766 244.961 188.757 241.378 190.903 238.49C193.047 235.603 196.191 233.618 199.719 232.922C203.25 232.226 206.911 232.87 209.991 234.728C213.07 236.586 215.348 239.523 216.38 242.97C217.41 246.416 217.121 250.123 215.567 253.367C214.014 256.612 211.308 259.161 207.976 260.516C206.255 261.221 204.412 261.583 202.554 261.587ZM202.554 240.54C201.36 240.54 200.191 240.863 199.168 241.476C198.145 242.086 197.308 242.963 196.744 244.014C196.18 245.064 195.911 246.247 195.966 247.439C196.02 248.629 196.398 249.782 197.055 250.776C197.713 251.77 198.628 252.566 199.704 253.081C200.779 253.597 201.973 253.811 203.159 253.701C204.346 253.591 205.482 253.162 206.445 252.459C207.407 251.754 208.16 250.804 208.625 249.706C209.048 248.704 209.216 247.613 209.115 246.529C209.015 245.446 208.647 244.404 208.047 243.498C207.445 242.589 206.631 241.846 205.672 241.33C204.715 240.814 203.645 240.543 202.556 240.54H202.554Z"
                        fill="white"
                    />
                    <path
                        d="M121.148 104.382C119.797 104.382 118.477 103.982 117.354 103.231C116.231 102.481 115.355 101.414 114.838 100.166C114.321 98.918 114.186 97.5448 114.45 96.22C114.713 94.8951 115.364 93.6782 116.319 92.7231C117.274 91.7678 118.491 91.1174 119.816 90.854C121.14 90.5904 122.514 90.7256 123.762 91.2425C125.01 91.7595 126.076 92.6349 126.827 93.758C127.577 94.8812 127.978 96.2015 127.978 97.5524C127.972 99.362 127.251 101.096 125.971 102.376C124.692 103.655 122.958 104.377 121.148 104.382ZM121.148 94.7966C120.608 94.7966 120.08 94.9569 119.63 95.257C119.181 95.5572 118.831 95.9838 118.624 96.483C118.417 96.9822 118.363 97.5316 118.469 98.0614C118.574 98.5914 118.834 99.0781 119.216 99.4602C119.598 99.8423 120.085 100.102 120.615 100.208C121.145 100.313 121.694 100.259 122.194 100.052C122.693 99.8456 123.119 99.4955 123.42 99.0462C123.72 98.597 123.88 98.0689 123.88 97.5284C123.88 96.8039 123.592 96.1091 123.08 95.5967C122.567 95.0844 121.873 94.7966 121.148 94.7966Z"
                        fill="#84ECFF"
                    />
                    <path
                        d="M309.705 137.662C306.961 137.662 304.28 136.849 301.999 135.325C299.718 133.8 297.939 131.634 296.89 129.099C295.839 126.565 295.566 123.776 296.1 121.085C296.636 118.394 297.957 115.923 299.897 113.983C301.837 112.043 304.308 110.722 307 110.186C309.69 109.651 312.479 109.926 315.014 110.976C317.547 112.026 319.714 113.804 321.238 116.085C322.762 118.366 323.576 121.048 323.576 123.791C323.573 127.469 322.11 130.995 319.51 133.596C316.909 136.196 313.384 137.659 309.705 137.662ZM309.705 114.018C307.772 114.018 305.882 114.591 304.275 115.665C302.669 116.739 301.416 118.265 300.676 120.051C299.937 121.837 299.742 123.802 300.12 125.698C300.497 127.594 301.428 129.335 302.794 130.702C304.162 132.069 305.903 133 307.798 133.377C309.695 133.754 311.659 133.56 313.444 132.821C315.231 132.081 316.757 130.828 317.831 129.221C318.905 127.614 319.479 125.724 319.479 123.791C319.475 121.2 318.445 118.716 316.613 116.883C314.781 115.051 312.296 114.021 309.705 114.018Z"
                        fill="#84ECFF"
                    />
                    <path
                        d="M89.8032 294.419C88.4268 294.419 87.0813 294.011 85.9367 293.247C84.7923 292.481 83.9002 291.395 83.3735 290.123C82.8469 288.851 82.7089 287.452 82.9775 286.102C83.246 284.752 83.9088 283.511 84.8821 282.539C85.8555 281.566 87.0956 280.903 88.4455 280.633C89.7955 280.365 91.1948 280.503 92.4666 281.03C93.7382 281.557 94.8252 282.448 95.5899 283.593C96.3546 284.738 96.7628 286.083 96.7628 287.459C96.7609 289.306 96.0272 291.073 94.7223 292.378C93.4177 293.683 91.6485 294.418 89.8032 294.419ZM89.8032 284.597C89.2373 284.597 88.684 284.766 88.2134 285.081C87.7429 285.394 87.3761 285.841 87.1594 286.365C86.9428 286.887 86.8861 287.463 86.9966 288.018C87.1071 288.573 87.3795 289.083 87.7797 289.483C88.1799 289.883 88.6899 290.156 89.245 290.266C89.8001 290.377 90.3755 290.32 90.8983 290.104C91.4212 289.887 91.8682 289.52 92.1826 289.05C92.4971 288.578 92.665 288.025 92.665 287.459C92.6641 286.701 92.3622 285.973 91.8258 285.438C91.2893 284.9 90.562 284.599 89.8032 284.597Z"
                        fill="#3382EB"
                    />
                    <path
                        d="M106.803 53.9664C104.421 53.9664 102.093 53.2603 100.113 51.9372C98.1329 50.6141 96.5897 48.7337 95.6783 46.5335C94.7669 44.3332 94.5285 41.9122 94.9931 39.5766C95.4577 37.2408 96.6045 35.0954 98.2885 33.4114C99.9723 31.7275 102.118 30.5808 104.453 30.1162C106.789 29.6515 109.21 29.89 111.41 30.8013C113.611 31.7127 115.491 33.256 116.814 35.2362C118.137 37.2161 118.843 39.5442 118.843 41.9256C118.84 45.118 117.57 48.1785 115.313 50.4358C113.055 52.6931 109.995 53.9627 106.803 53.9664ZM106.803 33.9827C105.232 33.9827 103.696 34.4485 102.39 35.3213C101.083 36.194 100.065 37.4347 99.4642 38.886C98.863 40.3373 98.7057 41.9345 99.0121 43.4752C99.3187 45.016 100.075 46.4313 101.186 47.5421C102.297 48.653 103.712 49.4095 105.253 49.7159C106.794 50.0225 108.391 49.8652 109.842 49.2641C111.294 48.6627 112.534 47.6448 113.407 46.3386C114.28 45.0324 114.746 43.4966 114.746 41.9256C114.743 39.8198 113.905 37.8011 112.416 36.312C110.927 34.8231 108.908 33.9853 106.803 33.9827Z"
                        fill="#185AF5"
                    />
                    <path
                        d="M71.0335 124.419C69.3777 124.42 67.759 123.93 66.3821 123.01C65.0051 122.091 63.9318 120.784 63.298 119.254C62.6641 117.725 62.4979 116.041 62.8209 114.418C63.1436 112.794 63.9409 111.302 65.1116 110.131C66.2824 108.96 67.7741 108.163 69.3979 107.84C71.0218 107.518 72.7051 107.684 74.2346 108.317C75.7642 108.951 77.0713 110.025 77.9907 111.402C78.9101 112.779 79.4004 114.397 79.3999 116.053C79.3963 118.271 78.5136 120.397 76.9453 121.965C75.3772 123.533 73.2513 124.416 71.0335 124.419ZM71.0335 111.784C70.1889 111.784 69.3633 112.033 68.6605 112.502C67.9579 112.97 67.4098 113.636 67.0854 114.416C66.7613 115.196 66.6753 116.054 66.8387 116.883C67.0021 117.711 67.4073 118.473 68.0033 119.071C68.5992 119.669 69.3591 120.078 70.187 120.244C71.0149 120.411 71.8736 120.328 72.6546 120.007C73.4356 119.686 74.1039 119.141 74.5753 118.44C75.0464 117.739 75.2993 116.914 75.302 116.07C75.3038 115.508 75.1947 114.951 74.9812 114.431C74.7675 113.911 74.4535 113.439 74.0571 113.04C73.6605 112.642 73.1895 112.326 72.6706 112.11C72.1518 111.893 71.5955 111.782 71.0335 111.781V111.784Z"
                        fill="#185AF5"
                    />
                    <path
                        d="M105.369 218.179L60.6988 220.791L56.543 182.972L105.119 180.131L105.369 218.179Z"
                        fill="white"
                    />
                    <path
                        d="M63.6929 228.868C63.1998 228.868 62.7231 228.691 62.3505 228.369C61.978 228.045 61.7344 227.598 61.6644 227.111L55.4699 183.898C55.4297 183.618 55.4483 183.332 55.5243 183.059C55.6004 182.786 55.7323 182.532 55.9117 182.311C56.0911 182.092 56.3141 181.913 56.5666 181.784C56.8192 181.655 57.0957 181.578 57.3788 181.563L108.018 178.605C108.301 178.589 108.584 178.631 108.85 178.73C109.116 178.828 109.359 178.981 109.562 179.177C109.766 179.376 109.927 179.612 110.034 179.875C110.142 180.138 110.193 180.42 110.186 180.701L109.104 224.323C109.091 224.838 108.885 225.327 108.528 225.698C108.171 226.067 107.688 226.288 107.174 226.317L63.8295 228.865L63.6929 228.868ZM59.8409 185.525L65.455 224.666L105.068 222.354L106.048 182.826L59.8409 185.525Z"
                        fill="#101014"
                    />
                    <path
                        d="M81.9316 181.368C81.602 181.368 81.277 181.289 80.9845 181.138C80.6919 180.987 80.4402 180.766 80.2508 180.496C80.0615 180.226 79.94 179.915 79.8967 179.588C79.8533 179.261 79.8895 178.928 80.0023 178.619C81.4533 174.724 83.1235 170.916 85.005 167.21C89.2429 158.96 93.1085 154.824 96.8239 154.575C98.586 154.455 101.13 155.149 103.227 159.141C104.716 161.971 104.863 164.816 103.664 167.592C99.887 176.348 83.1917 181.098 82.4917 181.296C82.3088 181.345 82.1207 181.368 81.9316 181.368ZM97.1756 158.656H97.1039C94.0749 158.864 89.079 167.193 85.425 175.986C90.684 173.995 97.9986 170.382 99.9041 165.957C100.587 164.355 100.495 162.747 99.6003 161.039C99.0061 159.946 98.1249 158.656 97.1585 158.656H97.1756Z"
                        fill="#101014"
                    />
                    <path
                        d="M82.8273 181.312C82.6663 181.312 82.5059 181.294 82.3493 181.256C80.693 180.861 66.0638 177.158 62.7581 169.376C61.6619 166.791 61.918 164.008 63.4992 161.324C65.7222 157.567 68.2527 156.977 69.9875 157.158C73.4706 157.52 76.9332 161.256 80.5735 168.57C82.1748 171.828 83.5776 175.18 84.7738 178.606C84.8779 178.914 84.9071 179.243 84.8591 179.565C84.811 179.887 84.6872 180.193 84.4977 180.456C84.308 180.72 84.0583 180.936 83.7691 181.084C83.4798 181.233 83.1593 181.312 82.8341 181.312H82.8273ZM69.4479 161.228C68.5156 161.228 67.6244 162.4 67.0302 163.407C66.0944 164.991 65.9373 166.378 66.5282 167.775C68.1434 171.575 74.7034 174.536 79.5046 176.151C76.4996 168.639 72.3095 161.515 69.5707 161.232L69.4479 161.228Z"
                        fill="#101014"
                    />
                    <defs>
                        <linearGradient
                            id="paint0_linear_1043_2424"
                            gradientUnits="userSpaceOnUse"
                            x1="89.0215"
                            x2="301.47"
                            y1="201.781"
                            y2="201.781"
                        >
                            <stop stop-color="#89F7FE"/>
                            <stop offset="1" stop-color="#66A6FF"/>
                        </linearGradient>
                    </defs>
                </svg>
            </div>
        </div>

        <div :class="{ 'disabled': isPageDisabled }" class="container">

            <div class="title-top">
                <div class="quotes-title">
                    <strong>
                        {{ subTitle }}
                    </strong>
                </div>

                <div class="quotes-sub-title">
                    <p>
                        {{ title }}
                        <p v-if="quoteType === 'home'" v-html="$trans('quote-results.home.compareWithTreasuryPrompt')" />
                        <span
                            v-if="loader"
                            class="loader-page"
                            v-html="$icon('loader')"
                        ></span>
                    </p>
                </div>

                <div class="quotes-company-list">
                    <h3>ההצעה כוללת את החברות הבאות:</h3>
                    <div class="image-wrapper">
                        <img
                        v-for="(quote, i) in quotes"
                              :alt="quote.company"
                            :src="quote.logo"
                            :title="quote.company" />
                    </div>
                </div>
            </div>
            <div class="flex flex-col gap-4 my-8">
                <div
                    v-for="(quote, i) in quotes"
                    :id="'quote-item-' + i"
                    class="quote-wrapper relative"
                    :key="i"
                >
                    <app-quote-item
                        :policyIncludesKeys="policyIncludesKeys"
                        :quote="quote"
                        :type="quoteType"
                        :hide-logo="false"
                        @details-click="handleDetailsClick(quote)"
                        @protection-click="handleProtectionClick(quote)"
                    ></app-quote-item>

                    <div v-if="i === 0" class="mark">

                        <svg fill="none" height="105" viewBox="0 0 104 105" width="104"
                             xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_d_1_4)">
                                <path
                                    d="M64.4839 23.2658L61.5961 18.4595C59.6078 15.1503 55.1514 14.3655 52.1522 16.7966L47.7964 20.3272C46.5918 21.3036 44.969 21.5902 43.5029 21.0853L38.2013 19.2598C34.551 18.0028 30.6328 20.2662 29.8979 24.0563L28.8306 29.5608C28.5355 31.0831 27.4765 32.3457 26.0289 32.9014L20.7942 34.9107C17.1899 36.2942 15.6433 40.5466 17.5166 43.9224L20.2372 48.8251C20.9896 50.181 20.99 51.8289 20.2382 53.1851L17.5198 58.0891C15.6481 61.4657 17.1967 65.7174 20.8016 67.0992L26.0372 69.1062C27.4851 69.6612 28.5446 70.9233 28.8405 72.4454L29.9103 77.9495C30.6469 81.7392 34.5661 84.0008 38.2159 82.7422L43.5166 80.9142C44.9825 80.4087 46.6054 80.6945 47.8104 81.6703L52.1679 85.199C55.1682 87.6286 59.6242 86.8419 61.6111 83.5317L64.4967 78.7241C65.2946 77.3946 66.7216 76.5704 68.272 76.5433L73.8782 76.4455C77.7383 76.3782 80.646 72.9112 80.0403 69.0984L79.1606 63.5607C78.9173 62.0293 79.4805 60.4807 80.6508 59.4634L84.8826 55.7849C87.7963 53.2521 87.7952 48.7271 84.8804 46.1957L80.6469 42.5191C79.4762 41.5024 78.9122 39.954 79.1548 38.4225L80.032 32.8844C80.636 29.0713 77.7266 25.6057 73.8665 25.5401L68.2602 25.4449C66.7099 25.4185 65.2825 24.5949 64.4839 23.2658Z"
                                    fill="url(#paint0_linear_1_4)" stroke="white" stroke-width="1.85699"/>
                                <path
                                    d="M45.1216 45.0097V43.8498V41.8667L44.9844 40.4075H47.2419L47.3916 41.8667V43.8498L47.3791 44.6356L45.1216 45.0097ZM48.2062 47.6289V45.9576H50.3889C50.6633 45.9576 50.8795 45.8911 51.0375 45.7581C51.1954 45.6167 51.3035 45.4379 51.3617 45.2218C51.4283 44.9973 51.4615 44.7644 51.4615 44.5233V43.5131C51.4615 43.2719 51.4283 43.0433 51.3617 42.8271C51.3035 42.6026 51.1954 42.4238 51.0375 42.2908C50.8795 42.1494 50.6633 42.0787 50.3889 42.0787H48.2062V40.4075H51.0375C51.6528 40.4075 52.1558 40.5488 52.5466 40.8315C52.9457 41.1059 53.2409 41.4884 53.4321 41.979C53.6317 42.4612 53.7315 43.0142 53.7315 43.6378V44.3986C53.7315 45.0222 53.6317 45.5793 53.4321 46.0699C53.2409 46.5521 52.9457 46.9346 52.5466 47.2173C52.1558 47.4917 51.6528 47.6289 51.0375 47.6289H48.2062ZM58.7349 47.6289V42.64C58.7349 42.4488 58.6892 42.3074 58.5977 42.2159C58.5062 42.1245 58.3649 42.0787 58.1736 42.0787H54.7313V40.4075H58.8222C59.2379 40.4075 59.608 40.4865 59.9322 40.6444C60.2648 40.8024 60.5267 41.056 60.718 41.4052C60.9092 41.7462 61.0048 42.1993 61.0048 42.7647V47.6289H58.7349ZM54.6315 47.6289V44.199L54.9433 43.3634H56.9015V44.199V47.6289H54.6315ZM43.7118 56.5857L43.4125 53.1184L43.3376 51.2725H45.4829L45.408 53.1184L45.1087 56.5857H43.7118ZM44.4102 59.7786C44.0527 59.7786 43.7534 59.6539 43.5122 59.4044C43.2794 59.1466 43.163 58.839 43.163 58.4815C43.163 58.1156 43.2794 57.808 43.5122 57.5585C43.7534 57.3091 44.0527 57.1843 44.4102 57.1843C44.7761 57.1843 45.0754 57.3091 45.3082 57.5585C45.5411 57.808 45.6575 58.1156 45.6575 58.4815C45.6575 58.839 45.5411 59.1466 45.3082 59.4044C45.0754 59.6539 44.7761 59.7786 44.4102 59.7786ZM48.2935 59.6289L50.4387 54.0787H46.9714V52.4075H52.7087V54.2534L50.5635 59.6289H48.2935ZM46.9714 54.0787V50.6863H48.992V54.0787H46.9714ZM53.6537 59.6289V53.8667L53.5165 52.4075H55.7739L55.9236 53.8667V59.6289H53.6537ZM57.5615 59.6289V55.538C57.5615 55.1971 57.5947 54.9019 57.6613 54.6525C57.7278 54.403 57.8151 54.2118 57.9232 54.0787H56.863V52.4075H60.8916V54.0787H59.9686C59.8855 54.2866 59.8397 54.5277 59.8314 54.8021C59.8314 55.0682 59.8314 55.3135 59.8314 55.538V59.6289H57.5615Z"
                                    fill="white"/>
                            </g>
                            <defs>
                                <filter id="filter0_d_1_4" color-interpolation-filters="sRGB"
                                        filterUnits="userSpaceOnUse"
                                        height="104.286" width="103.4"
                                        x="0.191559" y="0.539815">
                                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                    <feColorMatrix in="SourceAlpha" result="hardAlpha"
                                                   type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                                    <feOffset dy="1.68606"/>
                                    <feGaussianBlur stdDeviation="7.79802"/>
                                    <feComposite in2="hardAlpha" operator="out"/>
                                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"/>
                                    <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_1_4"/>
                                    <feBlend in="SourceGraphic" in2="effect1_dropShadow_1_4" mode="normal"
                                             result="shape"/>
                                </filter>
                                <linearGradient id="paint0_linear_1_4" gradientUnits="userSpaceOnUse" x1="6.67849"
                                                x2="97.5083" y1="43.1938"
                                                y2="59.1881">
                                    <stop stop-color="#185AF5"/>
                                    <stop offset="1" stop-color="#72E1D1"/>
                                </linearGradient>
                            </defs>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import QuoteProgress from "../QuoteSteps/Progress";
import trans from "../../trans";
import ScrollLogos from './ScrollLogos.vue';
import PolicyDetails from "./PolicyDetails.vue";

export default {
    // mixins: [QuoteStep],

    props: {},

    components: {
        QuoteProgress,
        ScrollLogos,
        PolicyDetails
    },

    data() {
        return {
            loader: true,
            loading: false,
            calcTitle: this.$trans("quote-results.static.calculate"),
            calcSubTitle: this.$trans("quote-results.static.calculate_sub_text"),
            title: "",
            subTitle: "",
            steps: window.yna.steps,
            step: window.yna.quote.step,
            quoteType: window.yna.quote.type,
            quotes: [],
            timer: null,
            selectedQuote: null,
            returnLink: window.yna.quote.index,
            form: window.yna.form,
            returnToken: window.yna.returnToken,
            quote_request_id: window.yna.quote
                ? window.yna.quote.request_id
                : null,
            stepName: 'CarQuoteDiscounts',
            allsurance_logo: require("../../../images/allsurance_logo_loader.svg"),
            surely_logo: require("../../../images/logo_2.png"),
            logo: require("../../../images/loader_logo.svg"),
            companies_loader: require("../../../images/companies_loader_frame.png"),

            policyIncludesKeys: ["drag", "windowpane", "replace_car"],

            isProtectionDetailsOpen: false,
            isPolicyDetailsOpen: false,
            isDiscountOpen: false,
            isNoFoundOpen: false,
            showDiscountBanner: true,
            isPageDisabled: window.yna.quote.type === 'car',

        };
    },

    mounted() {

        this.fetchData();

        document
            .querySelector(".quote-prev-link")
            .style
            .display = "flex";

        document
            .querySelector(".quote-prev-link")
            .addEventListener("click", e => {
                e.preventDefault();

                this.quoteStepPrev();
            });
    },
    watch: {
        loader(newValue) {
            if (!newValue) {
                setTimeout(() => {
                    this.isPageDisabled = false; // Enable the page after 3 seconds
                }, 3000);
            }
        },
    },

    methods: {

        trans,


        handlePolicyDetailsClose() {
            this.isPolicyDetailsOpen = false;
            this.isProtectionDetailsOpen = false;
            this.isDiscountOpen = false;
            this.isNoFoundOpen = false;
            this.selectedQuote = null;
        },

        quoteStepPrev() {
            window
                .history
                .back();
        },

        async validateStep() {

            const formFields = this.form[this.stepName];

            this.loading = true;

            let response = await this.$api.post(
                `quote/${this.quote_request_id}/validate/${this.stepName}`,
                formFields
            );

            if (response.hasErrors()) {

                this.loading = false;
                // TODO: set error state and show to user
                return false;
            }

            this.loading = false;
            this.loader = true;
            this.isProtectionDetailsOpen = false;
            this.isPolicyDetailsOpen = false
            this.isDiscountOpen = false

            // close popup
            // submit to quotes again

            const res = await this.$api.post(
                "quote/" + this.quote_request_id,
                this.form
            );

            if (res.hasErrors()) {
                // handle errors
                return;
            }

            window.location.href = res.data().redirect;
            this.showDiscountBanner = false

            return true;
        },
        async fetchData() {
            this.loader = true;

            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }


            let url = `quote/${this.quote_request_id}/results`;

            if (this.returnToken) {
                url += "?return_token=" + this.returnToken;
            }

            const res = await this.$api.get(url);

            if (!res.data().ready) {

                const reloadTimeInSeconds = 1;

                this.timer = setTimeout(() => {
                    this.fetchData();
                }, reloadTimeInSeconds * 1000);

                return;
            }

            await this.$api.post(
                `quote/send-lead/${this.quote_request_id}`
            );

            // case no quotes found open no-matches-dialog
            if (res.data().quotes) {
                const quotes = res.data().quotes;
                if (Array.isArray(quotes)) {
                    // Handle as array
                    if (!quotes.length) {
                        this.isNoFoundOpen = true;
                    } else {
                        this.loader = false;
                        this.title = res.data().title;
                        this.subTitle = res.data().subTitle;
                        this.quotes = quotes;
                    }
                } else if (typeof quotes === 'object') {
                    // Handle as object
                    const keys = Object.keys(quotes);
                    if (!keys.length) {
                        this.isNoFoundOpen = true;
                    } else {
                        this.loader = false;
                        this.title = res.data().title;
                        this.subTitle = res.data().subTitle;
                        this.quotes = quotes;
                    }
                } else {
                    // Handle other types or error
                    console.error('Unexpected type for quotes:', typeof quotes);
                }
            } else {
                this.isNoFoundOpen = true;
            }

        },
        handleDetailsClick(quote) {
            this.isPolicyDetailsOpen = true;
            this.selectedQuote = quote;
        },
        handleProtectionClick(quote) {
            this.isProtectionDetailsOpen = true;
            this.selectedQuote = quote;
        },
        handleDiscountClick() {
            this.isDiscountOpen = true;
        },
        handleClose() {
            this.isPolicyDetailsOpen = false;
            this.isProtectionDetailsOpen = false;
            this.isDiscountOpen = false;
            this.isNoFoundOpen = false;
            this.selectedQuote = null;
        }
    },

    computed: {
        policyIncludes() {
            if (this.selectedQuote) {
                return this.selectedQuote.policyIncludes[this.quoteType];
            }

            return {};

        },
        progressSteps() {
            return this.steps.filter(step => step.includeInCount);
        },

        currentStep() {
            return this.steps[this.step];
        },

        constants() {

            return this.currentStep.props.constants;
        },

        yesNoItems() {
            return [
                {
                    label: this.$trans("quote-results.static.yes"),
                    value: true
                },
                {
                    label: this.$trans("quote-results.static.no"),
                    value: false
                }
            ];
        },

        currency() {
            const currencySign = {
                car: "₪",
                travel: "$",
                pet: "₪",
                home: "₪"
            };

            return currencySign[this.quoteType];
        },

    }
};
</script>

<style lang="scss" scoped>

.page-quotes {
    padding-top: 40px;

    &::v-deep {
        .quote-policy-not-found {
            .modal-body {
                max-width: 800px;
                justify-content: space-around;


                .head-title {
                    color: $black;
                    font-size: 35px;
                    font-weight: $font-bold;
                    line-height: 46px; /* 131.429% */
                }

                .head-title.sub {
                    color: $primary-blue;
                    font-size: 25px;
                    font-weight: $font-normal;
                    margin-top: 20px;
                    margin-bottom: 30px;
                }
            }
        }
    }

    @media (max-width: $mobile) {
        padding-top: 0;
    }

    .page-quotes-prev {
        position: relative;
        padding: 0 137px;
    }

    .page-quotes-progress {
        max-width: $tablet;
        margin: 0 auto;
        padding: 0 10px;
    }

    .page-quotes-header {
        display: flex;
        position: relative;
        flex-direction: row;
        border-radius: 120px;
        border: 1px solid var(--blue, $primary-blue);
        background: var(--blue, $primary-blue);
        box-shadow: 3px 3px 17px 0 rgba(0, 0, 0, 0.1);
        height: 208px;
        width: 100%;
        // max-width: $tablet;
        max-width: $desktop;
        margin-inline: auto;
        z-index: 10000;
        animation: pulse 3s linear 1;

        @media (max-width: $mobile) {
            width: 95%;
            height: auto;
            margin: 40px auto;
        }

        .animation-container {
            position: absolute;
            top: 260px;
            right: 90px;
            animation: moveIcon 2s infinite;
        }

        @keyframes moveIcon {
            0%, 100% {
                transform: translateY(0);
            }
            50% {
                transform: translateY(10px);
            }
        }

        @keyframes pulse {
            0%, 100% {
                transform: scale(1);
            }
            20%, 80% {
                transform: scale(1.03);
            }
            40%, 60% {
                transform: scale(1);
            }
        }

        .header-logo-section {
            position: absolute;
            left: -50px;
            top: -70px;
            width: 300px;
            height: 300px;
            overflow: hidden;

            @media (max-width: $mobile) {
                left: 0;
                top: -35px;
                width: 120px;
                height: 120px;
            }
        }

        .header-inner {
            display: flex;
            justify-content: space-between;
            width: 100%;
            margin: 26px;
            padding: 22px 22px 22px 315px;
            border-radius: 120px;
            background: linear-gradient(87deg, $primary-blue 9%, $cyan 180%);

            @media (max-width: $tablet) {
                flex-direction: column;
                align-items: flex-start;
                padding: 10px 30px 10px 0;
                width: 70%;

            }

            @media (max-width: $mobile) {
                margin: 15px 10px;
                width: 80%;


            }

            .header-inner-container {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                width: 100%;

                @media (max-width: $tablet) {
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: space-between;
                    height: 100%;
                }


            }

            .header-title-section {
                font-style: normal;
                display: flex;
                flex-direction: column;
                padding-right: 40px;
                place-content: center;

                @media (max-width: $tablet) {
                    padding-right: 0;
                }

                @media (max-width: $mobile) {
                    margin: 10px 10px 0 0;
                    padding-right: 0;
                }

                .header-inner-title {
                    color: $white;
                    font-size: 35px;
                    font-weight: $font-semi-bold;
                    line-height: 39.5px;

                    @media screen and (max-width: $tablet) {
                        font-size: 20px;
                        line-height: 20px;
                        width: 70%;
                    }

                    @media screen and (max-width: $mobile) {
                        font-size: 16px;
                        line-height: 20px;
                        width: 70%;
                    }
                }

                .header-inner-subtitle {
                    color: rgba(255, 255, 255, 0.7);
                    font-size: 25px;
                    font-weight: $font-normal;

                    @media screen and (max-width: $tablet) {
                        font-size: 18px;
                    }

                    @media screen and (max-width: $mobile) {
                        font-size: 12px;
                    }
                }
            }
        }
    }

    .page-quotes-loader {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: $white;
        z-index: 50000;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        text-align: center;

        .allsurance-logo {
            position: absolute;
            left: 50%;
            top: 5%;
            transform: translateX(-50%);
            width: 200px;
        }

        .page-loader-progress {
            position: relative;
            margin-bottom: 55px;


            .page-loader-img {
                @media screen and (max-width: $mobile) {

                    svg {
                        width: 100%;
                        height: auto;
                    }
                }
            }

            @keyframes slideshow {
                0% {
                    left: 0;
                }
                100% {
                    left: -100%;
                }
            }

            .scroll-container {
                position: absolute;
                overflow: hidden;
                top: 29%;
                transform: translateY(-50%);
                width: 900px;
                height: 50px;
                z-index: -1;

                > div {
                    display: flex;
                    width: 200%;
                    height: 50px;

                    position: absolute;
                    overflow: hidden;

                    animation: slideshow 10s linear infinite;
                }


            }

        }

        .page-loader-text {
            font-size: 45px;
            font-weight: $font-bold;
            line-height: 1.32;
            color: $black;
            max-width: 590px;

            @media screen and (max-width: $mobile) {
                font-size: 20px;
                width: 400px;
            }
        }

        .page-loader-sub-text {
            color: rgba(0, 0, 0, 0.50);
            text-align: center;
            font-size: 25px;
            font-style: normal;
            font-weight: $font-normal;

            @media screen and (max-width: $mobile) {
                font-size: 15px;
                width: 400px;
            }
        }
    }
}

.top-recommended {
    position: absolute;
    background: $white;
    top: -28px;
    right: 0;
    left: 0;
    margin: auto;
    max-width: 250px;
    border: 1px solid;
    text-align: center;
    font-weight: $font-light;
    color: $primary-blue;
    font-size: 25px;
    border-radius: 50rem;
    padding: 11px;
    z-index: 555;
}

.mark {
    position: absolute;
    top: 50%;
    left: 96%;
    transform: translate(0, -50%);
    margin: auto;
    text-align: center;
    max-width: max-content;

    @media screen and (max-width: $desktop) {
        top: -15px;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    @media screen and (max-width: $mobile) {
    }
}

.title-top {
    text-align: center;
    margin: 50px auto 60px auto;
    max-width: 50%;

    @media screen and (max-width: $mobile) {
        max-width: 100%;
        margin: 50px auto 100px auto;

    }

    .quotes-title {
        margin-bottom: 23px;

        strong {
            color: $black;
            text-align: center;
            font-size: 45px;
            font-weight: $font-bold;

            @media (max-width: $mobile) {
                font-size: 25px;
            }
        }
    }

    .quotes-sub-title {
        margin-bottom: 10px;

        p {
            color: rgba(0, 0, 0, 0.5);
            text-align: center;
            font-size: 25px;
            font-weight: $font-normal;

            @media (max-width: $mobile) {
                font-size: 15px;
            }
        }
    }

    .quotes-company-list {
        .image-wrapper {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            gap: 35px;

            img {
                max-width: 120px;
                max-height: 70px;

                @media (max-width: $mobile) {
                    max-width: 60px;
                    max-height: 50px;
                }
            }
        }


        > h3 {
            margin-bottom: 30px;
            color: rgba(0, 0, 0, 0.8);
            text-align: center;
            font-size: 20px;
            font-weight: $font-normal;

            @media (max-width: $mobile) {
                font-size: 15px;
            }
        }


    }
}

.container {
    width: 100%;
    max-width: $desktop;
    margin: auto;
    padding: 0 15px;

    .quote-wrapper {

        @media (max-width: $mobile) {
            width: 90%;
            margin: 0 auto;
        }
    }
}

.container.disabled {
    position: relative;
    pointer-events: none;
}

.container.disabled::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    width: 120%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9999;
}

</style>
